<template>
    <Dialog>
        <template v-slot:title>{{ $t("message.title_add_ai_setting") }}</template>

        <template v-slot:body>
            <div style="padding-bottom:10px">
                <div style="padding-left:40px;padding-top:10px" v-t="'message.hint_selection_ai_template'"></div>
                <table style="margin-left:20px">
                    <tr>
                        <td v-for="processorTemplate in templates.slice(0, 7)" style="padding-top:10px;padding-bottom:10px">
                            <button class="transparent" type="button" v-on:click="handleChangeSelectTemplate(processorTemplate)">
                                <el-card :shadow="getCardShadowStyle(processorTemplate)" style="{ text-align:center; padding: 0; width: 120px; border-style: none; }">
                                    <img :src="getIcon(processorTemplate)" height="40px" /><br>
                                    <span>{{getLocaledText(processorTemplate.templateName)}}</span>
                                </el-card>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td v-for="template in templates.slice(7, 12)" style="padding-top:10px;padding-bottom:10px">
                            <button class="transparent" type="button" v-on:click="handleChangeSelectTemplate(template)">
                                <el-card :shadow="getCardShadowStyle(template)" style="{ text-align:center; padding: 0; width: 120px; border-style: none; }">
                                    <img :src="getIcon(template)" height="40px" /><br>
                                    <span>{{getLocaledText(template.templateName)}}</span>
                                </el-card>
                            </button>
                        </td>
                    </tr>
                </table>

                <div v-if="!redraw">
                    <AiAppSettingDefinitionEditForm
                        v-model="form"
                        :settingTitle="settingTitle"
                        :helpHtmlUrl="helpHtmlUrl"
                        :isNew="true"
                        @update:valid ="setButtonStatus($event)"
                    />
                </div>
            </div>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_back'"></el-button>
            <el-button class="dialog-ok-button" @click="save" :disabled="disableSave" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>
</template>

<script>
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";
import Dialog from "@/components/pc/common/Dialog";
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import AiAppSettingDefinitionEditForm from "@/components/pc/setting/ai-app/AiAppSettingDefinitionEditForm";

export default {
    mixins:[ AiAppSettingUtility ],

    components: { Dialog, AiAppSettingDefinitionEditForm },

    props: {
        processorTemplateList: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            templates: [],
            form: {
                displayName: null,
                sections: null
            },
            selectedTemplate: null,
            redraw: true,
            disableSave: true,
        };
    },

    computed: {
        settingTitle() {
            return this.getSettingTitle(this.selectedTemplate.templateName)
        },
        helpHtmlUrl() {
            return this.getHelpHtmlUrl(this.selectedTemplate.helpHtml)
        }
    },

    created: function() {
        if (this.processorTemplateList.length > 0) {
            for (let processorTemplate of this.processorTemplateList) {
                const helpHtml = 'helpHtml' in processorTemplate.template ? processorTemplate.template['helpHtml'] : null
                const iconUrl =  'iconUrl' in processorTemplate.template ? processorTemplate.template['iconUrl'] : null

                const template = {
                    type: AiAppSettingUtility.TYPE_PROCESSOR,
                    id : processorTemplate.id,
                    templateName : processorTemplate.template['name'],
                    displayName : this.getLocaledText(processorTemplate.template['defaultDisplayName']),
                    // displayNameValidator : processorTemplateUtil.getDisplayNameValidator(),
                    helpHtml : helpHtml,
                    iconUrl : iconUrl,
                    sections : processorTemplate.template['processors']
                }

                this.templates.push(template)
            }
        }

        this.handleChangeSelectTemplate(this.templates[0])
    },

    methods: {
        getCardShadowStyle(processorTemplate) {
            if (processorTemplate === this.selectedTemplate) {
                return "always"
            } else {
                return "hover"
            }
        },
        getIcon(template) {
            if ('iconUrl' in template) {
                if (template['iconUrl'] != null) {
                    return template.iconUrl;
                } else {
                    return processorTemplateUtil.getDefaultIconUrl()
                }
            }
            return processorTemplateUtil.getDefaultIconUrl();
        },
        handleChangeSelectTemplate(template) {
            if (this.selectedTemplate == null || template.templateName !== this.selectedTemplate.templateName) {
                this.selectedTemplate = template
                this.form.displayName = template.displayName
                this.form.sections = JSON.parse(JSON.stringify(template.sections))  // deep copy through JSON

                this.setButtonStatus(false)
                this.redraw = true;
                let self = this;
                this.$nextTick(function() {
                    self.redraw = false;
                });
            }
        },
        setButtonStatus(valid) {
            this.disableSave = !valid
        },
        save() {
            const self = this

            if (this.selectedTemplate.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                this.$emit('save', '/createprocessordefinition', {
                    templateId: this.selectedTemplate.id,
                    displayName: this.form.displayName,
                    fulfilledTemplate: {
                        processors : this.form.sections
                    }
                });
            }
        }
    }
}
</script>

<style scoped>

.is-always-shadow
{
    background-color: #ecf1fa;
}
.is-hover-shadow:hover
{
    background-color: #ecf1fa;
}

</style>
